<template lang="pug">
  div
</template>

<script>
export default {
  async mounted () {
    this.$store.dispatch('startTask', { id: 'authCallback' })
    try {
      await this.$store.dispatch('auth/handleAuthCallback')
      this.$store.dispatch('endTask', { id: 'authCallback' })
      window.location.hash = ''
      // Get current language
      const currentLang = this.$i18n.locale || 'en'
      // Redirect to language-prefixed root (dashboard)
      this.$router.push(`/${currentLang}`)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      this.$store.dispatch('clearTasks')
      // Get current language for login redirect too
      const currentLang = this.$i18n.locale || 'en'
      this.$router.push(`/${currentLang}/login`)
      this.$notify({ group: 'general', type: error.type, title: error.title, text: error.message, duration: -1 })
    }
  }
}
</script>
